import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StimulSoftReportComponent, ReportInfo } from './stimul-soft-report.component';
import { ThemeModule } from 'projects/sepidz-web-framework-shell/src/lib/@theme/theme.module';
import { TabularModule } from 'projects/sepidz-web-framework-shell/src/lib/tabular/tabular.module';
import { SharedModule } from 'projects/sepidz-web-framework-shell/src/lib/shared/shared.module';
import { SepidzGridModule } from 'projects/sepidz-web-framework-data-grid/src/lib/grid.module';
const components =  [StimulSoftReportComponent]
@NgModule({
    declarations: [...components,],
    exports: [...components],
    imports: [CommonModule,
        FormsModule,
        ThemeModule,
        TabularModule,
        SharedModule.forRoot(),
        SepidzGridModule],
    providers: [ReportInfo]
})
export class StimulSoftReportModule { }